"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TextInput = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ykbStyledComponents = require("../ykb-styled-components");
var _inputHOC = _interopRequireDefault(require("../Form/inputHOC"));
var _StyledTextInput = require("./StyledTextInput");
var _Icon = _interopRequireDefault(require("../Icon"));
var _excluded = ["defaultValue", "placeholder", "disabled", "disabledCopy", "htmlType", "validationItem", "validationOptions", "prefix", "suffix", "formItemLayout", "className", "allowClear", "inputRef", "invisible", "unMask", "mask", "validation", "viewMode", "addonAfter", "addonBefore", "readOnly", "size", "onFocus", "onBlur", "copyable", "backgroundColorType", "viewModeWithPrefixSuffix", "autoComplete"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var TextInput = exports.TextInput = /*#__PURE__*/function (_React$Component) {
  function TextInput() {
    var _this;
    (0, _classCallCheck2.default)(this, TextInput);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, TextInput, [].concat(args));
    (0, _defineProperty2.default)(_this, "state", {
      focused: false,
      inputValue: ''
    });
    (0, _defineProperty2.default)(_this, "handleKeyDown", function (e) {
      if (_this.props.onKeyDown) _this.props.onKeyDown(e);
    });
    (0, _defineProperty2.default)(_this, "handleBlur", function (e) {
      _this.setState({
        focused: false
      });
      if (_this.props.onBlur) {
        _this.props.onBlur(e);
      }
    });
    (0, _defineProperty2.default)(_this, "handleFocus", function (e) {
      _this.setState({
        focused: true
      });
      if (_this.props.onFocus) {
        _this.props.onFocus(e);
      }
    });
    (0, _defineProperty2.default)(_this, "stopDragDrop", function (e) {
      if (_this.props.pattern) {
        e.preventDefault();
        return false;
      }
    });
    (0, _defineProperty2.default)(_this, "handleCopyText", /*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee() {
      var _navigator, _navigator$clipboard;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (_navigator = navigator) === null || _navigator === void 0 ? void 0 : (_navigator$clipboard = _navigator.clipboard) === null || _navigator$clipboard === void 0 ? void 0 : _navigator$clipboard.writeText(_this.props.value ? _this.props.value : _this.state.inputValue);
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    (0, _defineProperty2.default)(_this, "onInput", function (e) {
      _this.setState({
        inputValue: e.target.value
      });
      if (_this.props.upperCase) {
        e.target.value = e.target.value.toLocaleUpperCase(_this.props.locale);
      }
    });
    (0, _defineProperty2.default)(_this, "clearTextInputValue", function (e) {
      if (e.target.tagName == 'svg') {
        e.target.parentElement.parentElement.parentElement.firstChild.value = '';
      } else if (e.target.tagName == 'path') {
        e.target.parentElement.parentElement.parentElement.parentElement.firstChild.value = '';
      }
      typeof _this.props.onChange === 'function' && _this.props.onChange('');
      typeof _this.props.handleClear === 'function' && _this.props.handleClear(e, '');
    });
    return _this;
  }
  (0, _inherits2.default)(TextInput, _React$Component);
  return (0, _createClass2.default)(TextInput, [{
    key: "renderLabeledIcon",
    value: function renderLabeledIcon(children, theme) {
      var props = this.props;
      var suffix = props.suffix;
      var _ref2 = (suffix === null || suffix === void 0 ? void 0 : suffix.props) || {},
        colorType = _ref2.colorType;
      if (!props.prefix && !props.suffix && !props.allowClear) {
        return /*#__PURE__*/_react.default.createElement(_StyledTextInput.ChildrenWrapper, null, children);
      }
      var cls = (0, _classnames.default)(props.className, {
        invisible: props.invisible
      });
      return /*#__PURE__*/_react.default.createElement(_StyledTextInput.StyledInputWrapper, {
        size: props.size,
        className: cls,
        style: props.style,
        theme: theme
      }, props.prefix && /*#__PURE__*/_react.default.createElement(_StyledTextInput.StyledInputPrefix, {
        size: props.size,
        theme: theme
      }, props.prefix), children, props.suffix && /*#__PURE__*/_react.default.createElement(_StyledTextInput.StyledInputSuffix, {
        size: props.size,
        theme: theme,
        colorType: colorType
      }, props.suffix), props.allowClear && !props.suffix && !props.prefix && !props.disabled && !props.readOnly && /*#__PURE__*/_react.default.createElement(_StyledTextInput.StyledInputAllowClear, {
        size: props.size,
        theme: theme
      }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
        name: "close-alt",
        onClick: this.clearTextInputValue
      })));
    }
  }, {
    key: "renderInput",
    value: function renderInput(theme) {
      var _this$props = this.props,
        defaultValue = _this$props.defaultValue,
        placeholder = _this$props.placeholder,
        disabled = _this$props.disabled,
        disabledCopy = _this$props.disabledCopy,
        htmlType = _this$props.htmlType,
        validationItem = _this$props.validationItem,
        validationOptions = _this$props.validationOptions,
        prefix = _this$props.prefix,
        suffix = _this$props.suffix,
        formItemLayout = _this$props.formItemLayout,
        className = _this$props.className,
        allowClear = _this$props.allowClear,
        inputRef = _this$props.inputRef,
        invisible = _this$props.invisible,
        unMask = _this$props.unMask,
        mask = _this$props.mask,
        validation = _this$props.validation,
        viewMode = _this$props.viewMode,
        addonAfter = _this$props.addonAfter,
        addonBefore = _this$props.addonBefore,
        readOnly = _this$props.readOnly,
        size = _this$props.size,
        onFocus = _this$props.onFocus,
        onBlur = _this$props.onBlur,
        copyable = _this$props.copyable,
        backgroundColorType = _this$props.backgroundColorType,
        viewModeWithPrefixSuffix = _this$props.viewModeWithPrefixSuffix,
        autoComplete = _this$props.autoComplete,
        rest = (0, _objectWithoutProperties2.default)(_this$props, _excluded);
      var cls = (0, _classnames.default)(className, (0, _defineProperty2.default)({
        disabled: disabled === true,
        invisible: invisible,
        readonly: readOnly,
        focused: this.state.focused
      }, "table-xs", size === 'xsmall'));
      return this.renderLabeledIcon(/*#__PURE__*/_react.default.createElement(_StyledTextInput.StyledInput, (0, _extends2.default)({
        onDragStart: this.stopDragDrop,
        onDrop: this.stopDragDrop,
        type: htmlType,
        className: cls,
        onInput: this.onInput
      }, rest, {
        ref: function ref(i) {
          if (inputRef) inputRef(i);
        },
        placeholder: placeholder,
        copyable: copyable,
        defaultValue: defaultValue,
        allowClear: allowClear,
        disabled: disabled || false,
        onKeyDown: this.handleKeyDown,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        size: size,
        autoComplete: autoComplete ? "on" : "off",
        readOnly: readOnly,
        theme: theme,
        addonAfter: addonAfter,
        addonBefore: addonBefore,
        $backgroundColorType: backgroundColorType,
        viewModeWithPrefixSuffix: viewModeWithPrefixSuffix
      })), theme);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var props = this.props;
      var _this$props2 = this.props,
        size = _this$props2.size,
        transparentAddons = _this$props2.transparentAddons,
        focusAll = _this$props2.focusAll,
        copyable = _this$props2.copyable;
      var focused = this.state.focused;

      // Not wrap when there is not addons
      if (!props.addonBefore && !props.addonAfter && !props.copyable) {
        return /*#__PURE__*/_react.default.createElement(_ykbStyledComponents.ThemeConsumer, null, function (theme) {
          return _this2.renderInput(theme);
        });
      }
      var groupCls = (0, _classnames.default)((0, _defineProperty2.default)({
        'focus-all': focusAll,
        focused: focused
      }, "table-xs", size === 'xsmall'));
      return /*#__PURE__*/_react.default.createElement(_ykbStyledComponents.ThemeConsumer, null, function (theme) {
        return /*#__PURE__*/_react.default.createElement(_StyledTextInput.StyledInputAddonWrapper, {
          style: props.style,
          theme: theme
        }, /*#__PURE__*/_react.default.createElement(_StyledTextInput.StyledInputGroup, {
          focusAll: focusAll,
          className: groupCls,
          size: size,
          theme: theme
        }, props.addonBefore && /*#__PURE__*/_react.default.createElement(_StyledTextInput.StyledInputAddon, {
          transparentAddons: transparentAddons,
          size: size,
          disabled: props.disabled,
          theme: theme
        }, props.addonBefore), _this2.renderInput(theme), props.addonAfter && /*#__PURE__*/_react.default.createElement(_StyledTextInput.StyledInputAddon, {
          transparentAddons: transparentAddons,
          size: size,
          disabled: props.disabled,
          theme: theme
        }, props.addonAfter), copyable && /*#__PURE__*/_react.default.createElement(_StyledTextInput.CopyButtonWrapper, null, /*#__PURE__*/_react.default.createElement(_StyledTextInput.CopyButton, {
          onClick: _this2.handleCopyText,
          size: size,
          disabled: props.disabledCopy,
          theme: theme
        }, /*#__PURE__*/_react.default.createElement(_StyledTextInput.CopyIcon, {
          name: "clone",
          size: size,
          color: "#fff",
          theme: theme
        })))));
      });
    }
  }]);
}(_react.default.Component);
TextInput.propTypes = {
  htmlType: _propTypes.default.oneOf(['text', 'email', 'number', 'password']),
  size: _propTypes.default.oneOf(['small', 'medium', 'large']),
  readOnly: _propTypes.default.bool,
  validation: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.object]),
  placeholder: _propTypes.default.string,
  onChange: _propTypes.default.func,
  onKeyDown: _propTypes.default.func,
  onFocus: _propTypes.default.func,
  onBlur: _propTypes.default.func,
  disabled: _propTypes.default.bool,
  defaultValue: _propTypes.default.string,
  value: _propTypes.default.string,
  form: _propTypes.default.object,
  allowClear: _propTypes.default.bool,
  prefix: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  suffix: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  addonAfter: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  addonBefore: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  focusAll: _propTypes.default.bool,
  backgroundColorType: _propTypes.default.oneOf(['primary', 'default', 'danger']),
  copyable: _propTypes.default.bool,
  autoComplete: _propTypes.default.bool,
  /**
   * It provides the regex control given by intervening on the key press.
   * If it complies with the rule, it writes into the input.
   *  */

  pattern: _propTypes.default.instanceOf(RegExp)
};
TextInput.defaultProps = {
  focusAll: false,
  htmlType: 'text',
  allowClear: false,
  readOnly: false,
  validation: {},
  size: 'medium',
  disabled: false,
  disabledCopy: false,
  backgroundColorType: 'default',
  autoComplete: true
};
TextInput.displayName = 'TextInput';
var _default = exports.default = (0, _inputHOC.default)(TextInput);